<template>
	<div class="container">
		<div class="container__aside">
			<div class="logo">
				<el-image :src="logo" class="logo__image" />
				{{$config.systemName}}
			</div>
			
			<el-menu :default-active="$route.path" router unique-opened>
				<template v-for="route in routes">
					<template v-if="route.meta.hideInMenu !== true && hasLeafNode(route.children)">
						<el-submenu :index="route.meta.index" v-if="route.children.length > 1" :key="route.meta.index">
							<template slot="title">
								<i :class="route.meta.icon" />
								<span slot="title">{{route.meta.title}}</span>
							</template>
							<el-menu-item
								v-for="_route in route.children"
								:index="_route.path == '' ? route.path : `${route.path}/${_route.path}`"
								:key="_route.meta.index"
								v-authorize="_route.meta.verifyCode"
							>
								{{_route.meta.title}}
							</el-menu-item>
						</el-submenu>
						<template v-else>
							<el-menu-item :index="route.path" :key="route.meta.index">
								<i :class="route.meta.icon" />
								<span slot="title">{{route.meta.title}}</span>
							</el-menu-item>
						</template>
					</template>
				</template>
			</el-menu>
		</div>
		<div class="container__main">
			<div class="container__header">
				<header class="header">
					<div class="header__message-group">
						<div class="header__message" @click="pendingAuditDialogVisible= true">
							<el-badge :value="$store.getters.pendingAuditCount" :max="99" :hidden="$store.getters.pendingAuditCount == 0 ? true : false">
								<el-tooltip effect="dark" content="审核" placement="bottom">
									<i class="el-icon-s-check" />
								</el-tooltip>
							</el-badge>
						</div>
						<div class="header__message" @click="push('/project/member-task')">
							<el-badge :value="$store.state.todoTaskCount" :max="99" :hidden="$store.state.todoTaskCount == 0 ? true : false">
								<el-tooltip effect="dark" content="任务" placement="bottom">
									<i class="el-icon-s-claim" />
								</el-tooltip>
							</el-badge>
						</div>
						<div class="header__message" @click="noticeIndexDialogVisible = true">
							<el-badge :value="$store.state.unreadNoticeCount" :max="99" :hidden="$store.state.unreadNoticeCount == 0 ? true : false">
								<el-tooltip effect="dark" content="通知" placement="bottom">
									<i class="el-icon-message-solid" />
								</el-tooltip>
							</el-badge>
						</div>
					</div>
					<div class="header__staff">
						<el-popover placement="bottom" trigger="hover">
							<div class="header__userinfo">
								<el-descriptions title="个人信息" :column="2">
									<el-descriptions-item label="员工ID">{{staff.staffNo}}</el-descriptions-item>
									<el-descriptions-item label="手机">{{staff.phone}}</el-descriptions-item>
									<el-descriptions-item label="部门">{{staff._branch.name}}</el-descriptions-item>
									<el-descriptions-item label="职位">{{staff.post}}</el-descriptions-item>
								</el-descriptions>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-button round size="small" @click="editPassword" style="width: 100%">修改密码</el-button>
									</el-col>
									<el-col :span="12">
										<el-button type="primary" round size="small" @click="logout" style="width: 100%">安全退出</el-button>
									</el-col>
								</el-row>
							</div>
							<div slot="reference">
								<el-image :src="staff._avatar" class="header__avatar" v-if="staff._avatar !== undefined" />
								<el-link type="info" :underline="false">{{staff.name}}</el-link>
							</div>
						</el-popover>
					</div>
				</header>
			</div>
			<router-view />
			<div class="container__footer">
				<footer class="footer">Copyright © 2018-{{currentYear}} Ennake. All Rights Reserved.</footer>
			</div>
		</div>

		<!--密码-->
		<password :visible.sync="passwordDialogVisible" @table-reload="logout" />

		<!--待审核-->
		<pending-audit :visible.sync="pendingAuditDialogVisible" />

		<!---通知-->
		<notice-index :visible.sync="noticeIndexDialogVisible" />
	</div>
</template>

<script>
import router from '@/mixins/router'
import logo from '@/assets/image/logo.png'
import {oneOf} from '@/utils/utils'
import routes from '@/router/routes'
import {readme} from '@/api/hr/staff'
import pendingAudit from './pending-audit'
import noticeIndex from './notice'
import password from './password'
export default {
	name: 'Container',
	mixins: [router],
	components: {
		pendingAudit,
		noticeIndex,
		password
	},
	data() {
		return {
			logo,
			routes,
			timer: null,
			passwordDialogVisible: false,
			pendingAuditDialogVisible: false,
			noticeIndexDialogVisible: false,
			staff: {
				_branch: {}
			}
		}
	},
	mounted() {
		readme().then(res=> {
			this.staff = res.data.data
		})

		// 待处理信息
		this.countMessage()
	},
	beforeDestroy() {
		if (this.timer === null) return false
		clearTimeout(this.timer)
	},
	computed: {
		currentYear() {
			return new Date().getFullYear()
		}
	},
	methods: {
		editPassword() {
			this.passwordDialogVisible = true
		},
		logout() {
      sessionStorage.removeItem(this.$config.tokenName)
      sessionStorage.removeItem(this.$config.verifyCodeName)
      this.$router.push({path: this.$config.defaultURL})
		},
		countMessage() {
			this.$store.dispatch('loadMessage')
			this.timer = setTimeout(this.countMessage, 60000)
		},
		hasLeafNode(routes) {
			const verifyCodeList = JSON.parse(sessionStorage.getItem(this.$config.verifyCodeName)) || []
			return routes.some(route => {
        return !route.meta ? true : oneOf(route.meta.verifyCode, verifyCodeList)
			})
		}
	}
}
</script>

<style lang="less" scoped>
@import "@/assets/style/color-var.less";
.container {
	display: flex;
	padding: 48px;

	&__aside {
		width: 232px;
		flex-shrink: 0
	}

	&__header {
		margin-bottom: 20px
	}

	&__main {
		margin-left: 48px;
		width: 0;
    flex: auto
	}

	&__footer {
		margin-top: 20px
	}
}
.header {
	display: flex;
	justify-content: space-between;
	background-color: #FFF;
	height: 52px;
	line-height: 52px;
	padding: 0 20px;

	&__message-group {
		display: flex
	}

	&__message {
		margin-right: 20px;
		cursor: pointer
	}

	&__message i {
		font-size: 24px
	}

	&__staff {
		display: flex;
		align-items: center
	}

	&__avatar {
		margin-right: 8px;
		width: 32px;
		height: 32px;
		vertical-align: middle;
		cursor: pointer;
		border-radius: 50%
	}

	&__userinfo {
		width: 320px
	}
}

.logo {
	margin-bottom: 20px;
	display: flex;
	height: 40px;
	line-height: 40px;
	font-size: 22px;
	font-family: '微软雅黑';

	&__image {
		margin-right: 8px;
		width: 40px;
		height: 40px;
		border-radius: 50%
	}
}

.footer {
	text-align: center;
	color: @text-color--c
}
</style>